import { render } from "./taxratesmodal.vue?vue&type=template&id=562e7a4c"
import script from "./taxratesmodal.vue?vue&type=script&lang=js"
export * from "./taxratesmodal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__